export default {
  props: {
    /**
     * Option for wider cards.
     */
    wide: {
      type: Boolean,
      default: false,
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/components/card/card.js